module.exports = __webpack_public_path__ + "static/media/EQUIVOQUE.51fdaf10.svg";